// This code creates a video element and uses the canPlayType method to determine
// if the WebM format with the vp8 and vorbis codecs is supported.
// If the method returns a value other than an empty string, it means that the browser supports WebM.

export default function checkWebMSupport() {
  const elem = document.createElement('video');

  return !!elem.canPlayType && elem.canPlayType('video/webm; codecs="vp8, vorbis"') !== '';
}
